import { pxToRem } from '@mos-cat/ds-theme';
import { Close } from '@mos-cat/ds-icons';
import { DialogProps, VisuallyHidden } from 'reakit';
import { Box } from '../Box/Box';
import { UtilityButton } from '../UtilityButton/UtilityButton';

export function ModalCloseButton({ hide }: Pick<DialogProps, 'hide'>) {
  return (
    <Box
      mt={['modalCloseBtnMT', 'modalBigCloseBtnMT']}
      mr={['modalCloseBtnMR', 'modalBigCloseBtnMR']}
      position="absolute"
      right={0}
      top={0}
      styles={{
        label: 'CLOSE',
      }}
    >
      <Box
        as={UtilityButton}
        onClick={hide}
        display="flex"
        alignItems="center"
        justifyContent="center"
        borderRadius="modalClose"
        size={['modalCloseButtonSize', 'modalBigCloseButtonSize']}
        styles={{
          color: 'modalCloseButtonColor',
          backgroundColor: 'modalCloseButtonBg',
          borderColor: 'modalCloseButtonBg',

          ':hover': {
            color: 'modalCloseButtonColor',
            backgroundColor: 'modalCloseButtonHoverBg',
            borderColor: 'modalCloseButtonHoverBg',
          },
          ':active': {
            color: 'modalCloseButtonColor',
            backgroundColor: 'modalCloseButtonActiveBg',
            borderColor: 'modalCloseButtonActiveBg',
          },
        }}
      >
        <Close width={pxToRem(24)} height={pxToRem(24)} />
        <VisuallyHidden>Закрыть</VisuallyHidden>
      </Box>
    </Box>
  );
}
